/** SPEC §21.3: gebeurtenissen voor webhooks. */
export const WEBHOOK_GEBEURTENISSEN = [
  'taak.aangemaakt',
  'taak.gewijzigd',
  'taak.verwijderd',
  'taak.teruggemeld',
  'project.aangemaakt',
  'project.gewijzigd',
  'project.verwijderd',
  'opmerking.aangemaakt',
  'afwezigheid.aangemaakt',
  'uren.goedgekeurd',
] as const;
export type WebhookGebeurtenis = (typeof WEBHOOK_GEBEURTENISSEN)[number] | 'ping';
export const WEBHOOK_LABEL: Record<(typeof WEBHOOK_GEBEURTENISSEN)[number], string> = {
  'taak.aangemaakt': 'Taak aangemaakt',
  'taak.gewijzigd': 'Taak gewijzigd (ook verplaatst)',
  'taak.verwijderd': 'Taak verwijderd',
  'taak.teruggemeld': 'Taak teruggemeld door engineer',
  'project.aangemaakt': 'Project aangemaakt',
  'project.gewijzigd': 'Project gewijzigd',
  'project.verwijderd': 'Project verwijderd',
  'opmerking.aangemaakt': 'Opmerking geplaatst',
  'afwezigheid.aangemaakt': 'Afwezigheid ingevoerd',
  'uren.goedgekeurd': 'Uren goedgekeurd',
};
/** Audit-actie → gebeurtenis (SPEC §21.3). */
export const AUDIT_NAAR_GEBEURTENIS: Record<string, (typeof WEBHOOK_GEBEURTENISSEN)[number]> = {
  'taak.nieuw': 'taak.aangemaakt',
  'taak.vervolg': 'taak.aangemaakt',
  'taak.wijzig': 'taak.gewijzigd',
  'taak.verplaats': 'taak.gewijzigd',
  'taak.opnieuw': 'taak.gewijzigd',
  'taak.verwijder': 'taak.verwijderd',
  'project.nieuw': 'project.aangemaakt',
  'project.wijzig': 'project.gewijzigd',
  'project.verwijder': 'project.verwijderd',
  'opmerking.nieuw': 'opmerking.aangemaakt',
  'afwezigheid.nieuw': 'afwezigheid.aangemaakt',
  'uren.goedgekeurd': 'uren.goedgekeurd',
};
/** Wachttijd in minuten na poging n (1-based); daarna mislukt. */
export const WEBHOOK_HERHAAL_MIN = [1, 5, 30, 120, 360, 1440];
export const WEBHOOK_UIT_NA = 50;
